import { ViewChild } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ThemePalette } from '@angular/material/core';
import { VerificarPermissoes } from './../model/verificarPermissoes.model';
import { Router } from '@angular/router';
import { ClientesService } from './../service/clientes.service';
import { Component, OnInit } from '@angular/core';
import { Cliente } from '../model/cliente.model';
import { BuscaService } from './../service/busca.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.css']
})
export class ClientesComponent implements OnInit {
  cliente: Cliente[] = [];
  load = true;
  value = 50;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  public columnsToDisplay = [
    'vc_nome',
    'vc_cnpj',
    'vc_nome_responsavel',
    'vc_email_responsavel',
    'bl_status',
    'acao1',
    'acao2'
  ];
  public dataSource: MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  constructor(private service: ClientesService, private router: Router, private buscaService: BuscaService) { }

  ngOnInit(): void {
    this.filtroDataSource();
    this.listarClientePaginate();
  }

  listarClientePaginate(): void {
    this.service.listarServiceClientes().subscribe(
      (resp: any) => {
        this.load = false
        this.cliente = resp;
        this.dataSource.data = this.cliente;
        this.dataSource.paginator = this.paginator;
      }, error => {
        if (error == "401") {
          localStorage.removeItem('token')
          this.router.navigate(['/'])
        }

      }
    )
  } 

  listarCliente(): void {
    this.service.listarServiceClientes().subscribe(resp => {
      this.cliente = resp;
    })
  }

  finalizar(cliente: Cliente): void {
    if (cliente.bl_status) {
      this.service.confirmAlert(cliente);
    } else {
      this.service.desativarAlert(cliente);
    }
  }

  filtraClientes(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  filtraStatus(status: string): void {
    if (status == "1") {
      this.dataSource.data = this.cliente.filter((item: Cliente) => {
        return item.bl_status === 1;
      });
    } else if (status == "0") {
      this.dataSource.data = this.cliente.filter((item: Cliente) => {
        return item.bl_status === 0;
      });
    } else {
      this.dataSource.data = this.cliente;
    }
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

  filtroDataSource(): void {
    this.dataSource.filterPredicate = (data: Cliente, filter: string) => {
      let nomeFiltro = this.buscaService.removerAcentos(data.vc_nome).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase()));
      let cpnjFiltro = this.buscaService.removerAcentos(data.vc_cnpj).toLowerCase().includes(this.buscaService.removerAcentos(filter.toLowerCase()));

      return nomeFiltro || cpnjFiltro
    }
  }
  clienteInativo(cliente: Cliente): boolean {
    return cliente.bl_status == 0;
}

}
